import { Grid } from "@mui/material";
import { useState } from "react";
import AddPageWrapper from "../../components/general/AddPageWrapper";
import ReusableTextField from "../../components/general/ReusableTextField";
import TitleBar from "../../components/general/TitleBar";
import MathEditor from "../../components/RichText/MathEditor";
import SectionSubmitRow from "./SectionSubmitRow";
import { TASK_SECTION, isTaskSectionDirty } from "./taskSectionEdit";

const contentContainerStyle = { margin: "36px 60px" };
const fieldsContainerStyle = { marginBottom: 40 };

export default function QuestionSection({
  task,
  setTask,
  isReadOnly,
  original,
  isEdit,
  submittingSection,
  onSubmitSection,
}) {
  const [expand, setExpand] = useState(false);

  const mainLanguage = task.languages?.[0] || {
    task_title: "",
    content: "",
  };

  const updateLanguageField = (field, value) => {
    const newTask = structuredClone(task);
    if (!newTask.languages?.[0]) return;
    newTask.languages[0][field] = value;
    setTask(newTask);
  };

  return (
    <>
      <TitleBar title="Question" state={expand} setState={setExpand} />
      {expand && (
        <AddPageWrapper>
          <Grid container style={contentContainerStyle}>
            <Grid container alignItems="center" style={fieldsContainerStyle}>
              <Grid item xs={3}>
                <ReusableTextField
                  type="withLabel"
                  placeholder="Language"
                  state="English"
                  grayedOut
                  fullWidth
                />
              </Grid>
              <Grid item xs={2} />
              <Grid item xs={7}>
                <ReusableTextField
                  type="withLabel"
                  placeholder="Label"
                  state={mainLanguage.task_title}
                  setState={updateLanguageField}
                  target="task_title"
                  disabled={isReadOnly}
                  grayedOut={isReadOnly}
                  onBlur
                  fullWidth
                  bgColor="#F2F2F2"
                />
              </Grid>
            </Grid>
            <Grid item xs={12} style={{ marginTop: 16, height: 320 }}>
              <MathEditor
                style={{ height: 300 }}
                value={mainLanguage.content ?? ""}
                onChange={
                  isReadOnly
                    ? undefined
                    : (html) => updateLanguageField("content", html)
                }
                readOnly={isReadOnly}
                placeholder="Task content (English) — supports math and images"
              />
            </Grid>
          </Grid>
          {isEdit && original && !isReadOnly && (
            <SectionSubmitRow
              disabled={
                !isTaskSectionDirty(original, task, TASK_SECTION.QUESTION) ||
                submittingSection !== null
              }
              submitting={submittingSection === TASK_SECTION.QUESTION}
              onSubmit={() => onSubmitSection(TASK_SECTION.QUESTION)}
            />
          )}
        </AddPageWrapper>
      )}
    </>
  );
}
